import React, { useEffect, useState } from "react";
import { Formik, Form } from 'formik';
import LogoDropdown from "components/UI/LogoDropdown";


const FundraisingFilter = ({ formData, platformList, projectList, onFilter }) => {
  const [projectLogo, setProjectLogo] = useState();

  useEffect(() => {
    if (formData.projectId) {
      const project = platformList.find(item => item.id === formData.projectId);
      setProjectLogo(project);
    }
    return () => { }
  }, [])

  const onSubmit = async (fields, { setStatus, setSubmitting }) => {
    const { projectId } = fields;
    setSubmitting(true);
    setStatus(true);
    onFilter({ projectId })
  }

  return (
    <div className="p-4">
      <div className="my-4 p-4 border-b-2 bg-white rounded">
        <Formik initialValues={formData} onSubmit={onSubmit}>
          {({ values, setFieldValue, setFieldTouched, isSubmitting, handleReset }) => (
            <Form noValidate className="flex flex-wrap items-end justify-between">
              <div className="mr-2 mb-2">
                <label className="block text-xs mb-2 uppercase font-bold text-left">Project</label>
                <LogoDropdown
                  list={projectList}
                  selectedProjectItem={projectLogo}
                  onLogo={(item) => {
                    setProjectLogo(item);
                    setFieldValue('projectId', item.id)
                  }}
                  name="projectId"
                  value={values.projectId}
                />
              </div>

              <div className="flex flex-row mb-2">
                <button type="reset" className="w-full bg-gray-300 text-gray-100 focus:outline-none font-bold py-2 px-2 rounded mr-2" onClick={() => {
                  setProjectLogo();
                  handleReset();
                }}>Clear</button>
                <button type="submit" disabled={isSubmitting} className="w-full bg-blue-800 text-white focus:outline-none font-bold py-2 px-2 rounded">{isSubmitting && <span className="spinner-border spinner-border-sm mr-1">wait..</span>}
                  Search
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default FundraisingFilter;